module.exports = __webpack_public_path__ + "img/icon-quac.dab01518.svg";